import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import api from "@/lib/api";
import { useI18n } from "@/lib/i18n";
import AppHeader from "@/components/AppHeader";
import { Button } from "@/components/ui/button";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";

export default function PaymentResult({ success }) {
  const { t } = useI18n();
  const [sp] = useSearchParams();
  const session_id = sp.get("session_id");
  const [status, setStatus] = useState({ payment_status: "pending" });
  const [tries, setTries] = useState(0);

  useEffect(() => {
    if (!session_id || !success) return;
    let cancelled = false;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${session_id}`);
        if (cancelled) return;
        setStatus(data);
        if (data.payment_status !== "paid" && tries < 15) {
          setTimeout(() => setTries((n) => n + 1), 2000);
        }
      } catch {}
    };
    poll();
  }, [session_id, tries, success]);

  const paid = status.payment_status === "paid";
  const isReforest = status.donation_type === "reforestation" || status.target_type === "reforestation";
  const fmtAmount = (a) => {
    const n = Number(a || 0);
    return Number.isInteger(n) ? String(n) : n.toFixed(2).replace(".", ",");
  };

  return (
    <div className="min-h-screen bg-[#F7F5F0]" data-testid="payment-result-page">
      <AppHeader />
      <div className="max-w-lg mx-auto px-6 py-24 text-center">
        {success ? (
          paid ? (
            <>
              <CheckCircle2 size={64} className="text-emerald-600 mx-auto" />
              <h1 className="font-heading text-3xl font-bold mt-4" data-testid="payment-thanks-title">{t("thanks_donation")}</h1>
              {isReforest ? (
                <p className="mt-2 text-slate-600" data-testid="payment-reforest-msg">
                  Grazie! La tua donazione di €{fmtAmount(status.amount)} al progetto di riforestazione è stata registrata.
                </p>
              ) : (
                <p className="mt-2 text-slate-600" data-testid="payment-generic-msg">
                  {t("donation_recorded").replace("{amount}", fmtAmount(status.amount))}
                </p>
              )}
            </>
          ) : (
            <>
              <Loader2 size={64} className="text-emerald-600 mx-auto animate-spin" />
              <h1 className="font-heading text-3xl font-bold mt-4">{t("confirming")}</h1>
              <p className="mt-2 text-slate-600">{t("waiting_stripe")}</p>
            </>
          )
        ) : (
          <>
            <XCircle size={64} className="text-slate-400 mx-auto" />
            <h1 className="font-heading text-3xl font-bold mt-4">{t("payment_cancelled")}</h1>
            <p className="mt-2 text-slate-600">{t("no_charge")}</p>
          </>
        )}
        <Link to="/map"><Button className="mt-8 rounded-full bg-emerald-600 hover:bg-emerald-700 hover:text-white text-white">{t("back_to_map_btn")}</Button></Link>
      </div>
    </div>
  );
}
